module.exports = __webpack_public_path__ + "static/media/suv-palladium.f8dbfb40.png";